import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DailyCountWidgetVm } from 'app/shared/generated/Dashboard/Models/DailyCountWidgetVm';
import { BusinessDaysWidgetVm } from 'app/shared/generated/Dashboard/Models/BusinessDaysWidgetVm';
import { DailyCountWeeklyWidgetVm } from 'app/shared/generated/Dashboard/Models/DailyCountWeeklyWidgetVm'

@Injectable({
	providedIn: 'root'
})
export class LandingService {
	constructor(private httpClient: HttpClient) { }

	getDailyCountWidgetVm(): Observable<DailyCountWidgetVm> {
		return this.httpClient.get<DailyCountWidgetVm>('api/Dashboard/GetDailyCountWidget');
	}

	getDailyCountWeeklyWidgetVm(httpParams: HttpParams): Observable<DailyCountWeeklyWidgetVm> {
		return this.httpClient.get<DailyCountWeeklyWidgetVm>('api/Dashboard/GetDailyCountWeeklyWidget', { params: httpParams });
	}

	getDashboardBusinessDays(){
		return this.httpClient.get<BusinessDaysWidgetVm>('api/Dashboard/GetBusinessDaysWidget');
	}
}
